import { setElementRef } from "../../../../middlewares/useElementRef";
import { PREFIX_REF, ELMENT_REF_PROP_KEY } from "../../enum";


const addRef = (refName, prop, node) => {

}

/** This just add entity to prop, the middleware will capture this property name to emit the element */
const useRefElement = (() => {
    return (refName, props, node) => {
        // props[ELMENT_REF_PROP_KEY] = [refName, node];
        setElementRef(props,refName,node)
        return Promise.resolve();
    }
})();

export default useRefElement;